// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__PT_Serif_7dbc8c', '__PT_Serif_Fallback_7dbc8c'","fontStyle":"normal"},"className":"__className_7dbc8c","variable":"__variable_7dbc8c"};